export default "/img/RU.d3e8edf099f3fd89a362b0bb4199c5d4.png";